import {
    LinkedContact,
    createHubPersona,
    HubPersona,
    runOwsRequestWithMonitor,
    Feature,
} from '../../../../shared';
import { PersonaType, getServiceAsync } from '../../../../service';

export function unlinkContact(contact: LinkedContact): Promise<HubPersona> {
    return getServiceAsync().then(service => {
        const containerPersonaId = service.Factory.itemId({
            Id: contact.containerPersonaId,
        });

        const itemToUnlik = service.Factory.itemId({
            Id: contact.sourceId,
            ChangeKey: contact.sourceChangeKey,
        });

        return runOwsRequestWithMonitor({
            scenarioName: 'UnlinkContact',
            feature: Feature.Linking,
            operation: () =>
                service.Operation.unlinkPersonaOperation({
                    personaId: containerPersonaId,
                    contactId: itemToUnlik,
                }),
            transformResponse: (personaType: PersonaType) => createHubPersona(personaType),
        });
    });
}

export function linkPersonas(
    personaIds: string[],
    adPersonaId: string,
    additionalLogProperties?: {}
): Promise<HubPersona> {
    return getServiceAsync().then(service => {
        const personaIdObjects = personaIds.map(personaId =>
            service.Factory.itemId({ Id: personaId })
        );
        const request = adPersonaId
            ? service.Factory.linkPersonasRequest({
                  PersonaIds: personaIdObjects,
                  AdPersonaToBeLinked: service.Factory.itemId({ Id: adPersonaId }),
              })
            : service.Factory.linkPersonasRequest({ PersonaIds: personaIdObjects });

        return runOwsRequestWithMonitor({
            scenarioName: 'LinkPersonas',
            feature: Feature.Linking,
            operation: () => service.Operation.linkPersonasOperation({ request }),
            qoSConfig: additionalLogProperties && {
                additionalQoSLogProperty: additionalLogProperties,
            },
            transformResponse: (personaType: PersonaType) => createHubPersona(personaType),
        });
    });
}
